import { authorizedFetch } from "./requestBuilder.js";

const API_BASE = process.env.REACT_APP_API_URL + "/api/verify";

export const startVerification = async (phoneNumber) => {
  try {
    return await authorizedFetch(`${API_BASE}/start/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        phoneNumber,
      }),
    });
  } catch (error) {
    console.error("Error sending verificaion:", error);
    throw error;
  }
};

export const checkVerificationCode = async (phoneNumber, code) => {
  try {
    const res = await authorizedFetch(`${API_BASE}/check/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        phoneNumber,
        code,
      }),
    });

    // TODO verify that this works
    const data = res;
    if (data.success === true) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    console.error("Error checking verification:", error);
    throw error;
  }
};
